import { getI18nLocale } from "@/plugins/i18n";
import { retryCompleteRequest } from "./complete-retry";

const axios = require("axios");

export default class OrderApi {
  constructor(tenantId) {
    this.client = axios.create({
      baseURL: `${process.env.VUE_APP_TRAINPLANET_API_URL_BASE}`,
    });
    this.client.interceptors.request.use((request) => {
      request.headers["Accept-Language"] = getI18nLocale();
      request.headers["tenantId"] = tenantId;
      request.headers["Content-Type"] = "application/json";

      if (request.url && request.url.includes("/jwt/")) {
        request.headers["AuthorizationJwt"] =
          "Bearer " + localStorage.getItem("auth_token");
      }

      return request;
    });
  }

  getPaymentSessionInvoice(
    system,
    orderId,
    checkoutUrl,
    confirmationUrl,
    payload = {}
  ) {
    return this.client.post(
      `orders/jwt/${orderId}/payment/${system}`,
      payload,
      {
        params: {
          checkoutUrl,
          confirmationUrl,
        },
      }
    );
  }

  async confirmationCheck(pushUrl, selectedShippingSlug) {
    this.twoAuthHeaderIsRequired = false;
    return await retryCompleteRequest(() =>
      this.client.post(pushUrl, {
        selectedShippingSlug,
      })
    );
  }

  updateOrder(orderId, data) {
    this.twoAuthHeaderIsRequired = true;
    return this.client.patch(`orders/jwt/${orderId}`, data);
  }

  async getLoggedTaxiPayload(orderId, tenantId) {
    this.twoAuthHeaderIsRequired = true;
    const { data } = await this.client.get(`orders/jwt/taxi-payload`, {
      params: {
        orderId,
        tenantId,
      },
    });
    return data;
  }
}
